import { Typography } from "@suraasa/placebo-ui"
import CheckBoxTextContainer from "features/Onboarding/Components/CheckBoxTextContainer"
import { getNavigationPortal } from "features/Onboarding/Navigation/utils"
import { FormPageProps } from "features/Onboarding/types"
import { useEffect, useState } from "react"

import {
  CurriculumOptions,
  getCurriculumFromValue,
} from "../CurriculumInformation"

const cbseTeachingLevels = [
  "Early Years (Pre-nursery to KG)",
  "Primary(Grade 1-4)",
  "Middle School(Grade 5-8)",
  "Secondary School (Grade 9 - 10)",
  "Senior Secondary School (Grade 9 - 12)",
  "Management/Leadership",
]

const ibTeachingLevels = [
  "Primary Years Programme (PYP)",
  "Middle Years Programme (MYP)",
  "Diploma Programme (DP)",
  "Career-related Programme (CP)",
]

const icseTeachingLevels = [
  "Early Years (Pre-nursery to KG)",
  "Primary(Grade 1-4)",
  "Middle School(Grade 5-8)",
  "Secondary School (Grade 9 - 10)",
  "Senior Secondary School (Grade 9 - 12)",
  "Management/Leadership",
]

const TeachingLevel = ({
  data,
  updateData,
  onNext,
  ...props
}: FormPageProps) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>(
    data.teachingLevels || []
  )

  const getOptions = () => {
    const curriculum =
      data.curricula.length > 0
        ? getCurriculumFromValue(data.curricula[0])
        : null

    if (!curriculum) {
      return cbseTeachingLevels
    }

    switch (curriculum) {
      case CurriculumOptions.CBSE:
        return cbseTeachingLevels
      case CurriculumOptions.ICSE_ISC:
        return icseTeachingLevels
      case CurriculumOptions.InternationalBaccalaureateIB:
        return ibTeachingLevels
      default:
        return cbseTeachingLevels
    }
  }

  const availableLevels = getOptions()

  const updateBackend = async (options: string[]) => {
    try {
      await props.apiAdapter.saveTeachingLevels(options)
    } catch (e) {
      console.error("Failed to update backend:", e)
    }
  }

  const toggleSelection = (selectedOption: string) => {
    const newOptions = selectedOptions.includes(selectedOption)
      ? selectedOptions.filter(option => option !== selectedOption)
      : [...selectedOptions, selectedOption]

    setSelectedOptions(newOptions)
    updateData({
      teachingLevels: newOptions,
    })
  }

  const handleSubmit = async () => {
    await updateBackend(selectedOptions)
    await onNext()
  }

  const isDisabled = selectedOptions.length === 0

  return (
    <div>
      <Typography variant="title2" color="onSurface.900">
        Which is your teaching level?
      </Typography>
      <div className="mt-4 flex flex-wrap gap-1">
        {availableLevels.map((option, index) => (
          <CheckBoxTextContainer
            key={index}
            text={option}
            minSize={false}
            isSelected={selectedOptions.includes(option)}
            onClick={() => toggleSelection(option)}
          />
        ))}
      </div>

      {getNavigationPortal({
        disableNext: isDisabled,
        onNext: handleSubmit,
        ...props,
      })}
    </div>
  )
}

export default TeachingLevel
